import { useCallback, useState } from 'react';

import { Button, Flex, Icons, Modal, RichContent, Typography } from 'components';

import { defaultContent, useExams } from 'features/exams';
import { createUrl } from 'app/utils';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAlert } from 'features/alert';

const LoadingIcon = styled(Icons)`
  width: 20px;
`;

const FinishModal = () => {
  const [loading, setLoading] = useState(false);

  const { examUuid, assessmentUuid } = useParams();
  const navigate = useNavigate();

  const { questions, examsDetails, setExamsAction, finalizeExam } = useExams();
  const { setAlert } = useAlert();

  const content = defaultContent(examsDetails);

  const handleFinishExam = useCallback(async () => {
    setLoading(true);

    await finalizeExam(examUuid, assessmentUuid, async (data) => {
      const { apiResultData: assessmentUuid, apiResultCode, apiResultMessage } = data;

      if (apiResultCode === 0) {
        navigate(createUrl('exams/result', [examUuid, assessmentUuid]));
      } else {
        setAlert({
          type: 'error',
          message: apiResultMessage,
        });
      }

      setLoading(false);
    });
  }, [examUuid, assessmentUuid]);

  const handleClose = useCallback(() => {
    if (loading) return;

    setExamsAction(null);
  }, [loading]);

  const hasUnansweredQuestions = !!questions?.find((question) => question.studentPracticeExamAssessmentQuestionAnswerChoiceUuid == null);

  return (
    <Modal onClose={handleClose}>
      <Flex maxWidth={{ d: 700 }} p={5} flexDirection="column" textAlign="center" alignItems="center">
        <Typography type="type6" color="gray_600" fontWeight="bold">
          {hasUnansweredQuestions ? content?.incompleteTitle : content?.finishTitle}
        </Typography>

        <Flex mt={4}>
          <RichContent defaultType="type2">{hasUnansweredQuestions ? content?.incompleteMessage : content?.finishMessage}</RichContent>
        </Flex>

        <Flex mt={4} flexDirection={{ m: 'column', d: 'row' }} alignItems="center">
          <Button mr={{ d: 2 }} onClick={handleClose} square color="dark_350">
            Revisar avaliação
          </Button>

          <Button minWidth={{ d: 200 }} ml={{ d: 2 }} mt={{ m: 2, d: 0 }} onClick={handleFinishExam} square color="dark_350">
            {loading ? <LoadingIcon icon="loading" spin /> : <>{hasUnansweredQuestions ? 'Enviar mesmo assim' : 'Sim, enviar avaliação'}</>}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default FinishModal;
